import {ActionList} from '@primer/react'
import {LinkExternalIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './EducationGroup.module.css'

export default function EducationGroup() {
  return (
    <ActionList.LinkItem href="/search/advanced" className={clsx('fgColor-accent', styles.linkItem)}>
      <ActionList.LeadingVisual className="fgColor-accent">
        <LinkExternalIcon />
      </ActionList.LeadingVisual>
      Advanced search
    </ActionList.LinkItem>
  )
}
